/**
 * Vlastná položka mimo cenníka (KOLO 210) — LED, oceľ od zámočníka.
 *
 * Čo je vlastná položka, rozhoduje server (`je_vlastna_polozka` v odpovedi
 * dielca, `pricing/vlastna_polozka.py`); tu sú len MJ a náhľad ceny v okne.
 * Cena v tabuľke je vždy zo servera.
 */

/** Rovnaký zoznam ako `MjVlastnej` na serveri (422 na inú). */
export const MJ_VLASTNEJ = ["ks", "kpl", "m", "m²", "kg", "hod"] as const;
export type MjVlastnej = (typeof MJ_VLASTNEJ)[number];

/**
 * Predaj 1 MJ pred ziskom zostavy — `nákup × (1 + réžia/100) + práca`; bez
 * nákupu `null`. Práca €/MJ (KOLO 216) bez réžie, ako položka cenníka.
 */
export function predajVlastnej(
  nakup: string,
  rezia: string,
  praca = "",
): number | null {
  if (nakup.trim() === "") return null;
  const n = Number(nakup);
  const r = rezia.trim() === "" ? 0 : Number(rezia);
  const p = praca.trim() === "" ? 0 : Number(praca);
  if (
    !Number.isFinite(n) ||
    !Number.isFinite(r) ||
    !Number.isFinite(p) ||
    n < 0 ||
    p < 0
  ) {
    return null;
  }
  // Nezaokrúhlené — spolu sa ráta z presnej ceny ako na serveri
  // (3 × 188,125 = 564,38, nie 3 × 188,13)
  return n * (1 + r / 100) + p;
}

/** Štítok v stĺpci Materiál — „vlastná · Elektro Novák". */
export function stitokVlastnej(dodavatel: string | null | undefined): string {
  const d = (dodavatel ?? "").trim();
  return d ? `vlastná · ${d}` : "vlastná položka";
}
